// UI Component: Zoe tasarım sistemine uygun buton bileşeni
import React from 'react';

const Button = ({ 
  children, 
  variant = 'primary', 
  size = 'medium',
  disabled = false,
  onClick,
  className = '',
  icon,
  ...props 
}) => {
  const baseStyles = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 'var(--spacing-sm)',
    fontWeight: '500',
    fontFamily: 'var(--font-primary)',
    transition: 'all 400ms cubic-bezier(0.25, 0.46, 0.45, 0.94)',
    cursor: disabled ? 'not-allowed' : 'pointer',
    border: 'none',
    outline: 'none',
    letterSpacing: '-0.01em'
  };

  const variants = {
    primary: {
      background: 'linear-gradient(135deg, var(--color-primary), #0891b2)',
      color: '#FFFFFF',
      border: 'none',
      boxShadow: 'var(--shadow-md)'
    },
    secondary: {
      background: 'rgba(255, 255, 255, 0.8)',
      color: 'var(--gray-700)',
      border: '1px solid rgba(148, 163, 184, 0.2)',
      backdropFilter: 'blur(10px)'
    },
    outline: {
      background: 'transparent',
      color: 'var(--color-primary)',
      border: '1px solid var(--color-primary)'
    }
  };

  const sizes = {
    small: {
      padding: 'var(--spacing-md) var(--spacing-xl)',
      fontSize: '14px',
      borderRadius: 'var(--radius-xl)'
    },
    medium: {
      padding: 'var(--spacing-lg) var(--spacing-2xl)',
      fontSize: '16px',
      borderRadius: 'var(--radius-2xl)'
    },
    large: {
      padding: 'var(--spacing-xl) var(--spacing-3xl)',
      fontSize: '18px',
      borderRadius: 'var(--radius-2xl)'
    }
  };

  const buttonStyles = {
    ...baseStyles,
    ...variants[variant],
    ...sizes[size],
    ...(disabled && {
      opacity: '0.6',
      cursor: 'not-allowed'
    })
  };

  const handleClick = (e) => {
    if (disabled) return;
    if (onClick) onClick(e);
  };

  const handleMouseEnter = (e) => {
    if (disabled) return;
    e.target.style.transform = 'translateY(-2px)';
    e.target.style.boxShadow = variant === 'primary' ? 'var(--shadow-xl)' : 'var(--shadow-lg)';
    if (variant === 'primary') {
      e.target.style.background = 'linear-gradient(135deg, #0891b2, var(--color-primary))';
    }
  };

  const handleMouseLeave = (e) => {
    if (disabled) return;
    e.target.style.transform = 'translateY(0)';
    e.target.style.boxShadow = variant === 'primary' ? 'var(--shadow-md)' : 'none';
    if (variant === 'primary') {
      e.target.style.background = 'linear-gradient(135deg, var(--color-primary), #0891b2)';
    }
  };

  return (
    <button
      style={buttonStyles}
      onClick={handleClick}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      disabled={disabled}
      className={className}
      {...props}
    >
      {icon && <span>{icon}</span>}
      {children}
    </button>
  );
};

export default Button; 